import { DateTime, Duration as LuxonDuration } from 'luxon';
export function countWorkHoursInWeek(scheduledShifts, targetWeek) {
    var hours = 0;
    var minutes = 0;
    scheduledShifts.forEach(function (scheduleShift) {
        if (targetWeek.contains(DateTime.fromISO(scheduleShift.shift.timeRange.start))) {
            hours =
                hours +
                    LuxonDuration.fromISO(scheduleShift.shift.duration.value).hours;
            minutes =
                minutes +
                    LuxonDuration.fromISO(scheduleShift.shift.duration.value)
                        .minutes;
        }
    });
    return hours + minutes / 60;
}
